/**
 * Sync #varient-image-update with selected variant/addon on steps 2–6
 */
(function () {
  const VARIANT_IMAGE_STEPS = [2, 3, 4, 5, 6];

  function setVariantImageFromLabel(label) {
    const imageBox = document.getElementById('varient-image-update');
    if (!label || !imageBox) return;

    const img = label.querySelector('.variant-swatch-img img');
    if (!img || !img.src) return;

    imageBox.innerHTML =
      '<img src="' +
      img.src +
      '" alt="' +
      (img.alt || '') +
      '" width="' +
      (img.width || '') +
      '" height="' +
      (img.height || '') +
      '" loading="lazy" class="variant-main-image">';
  }

  function syncVariantImageForActiveStep() {
    const current = typeof window.getConfiguratorCurrentStep === 'function'
      ? window.getConfiguratorCurrentStep()
      : null;

    const stepId = current ? 'step' + current : null;
    const scope = stepId ? document.getElementById(stepId) : document;
    if (!scope) return;

    const checked = scope.querySelector('.addon-checkbox:checked');
    if (checked) {
      const label = checked.closest('label.cd-custom-varient');
      if (label) {
        setVariantImageFromLabel(label);
        return;
      }
    }

    const radio = scope.querySelector('.cd-custom-varient input[type="radio"]:checked');
    if (radio) {
      const label =
        (radio.id && document.querySelector('label[for="' + radio.id + '"]')) ||
        radio.closest('label.cd-custom-varient');
      if (label) {
        setVariantImageFromLabel(label);
        return;
      }
    }

    const firstLabel = scope.querySelector('label.cd-custom-varient');
    if (firstLabel) setVariantImageFromLabel(firstLabel);
  }

  function setDefaultImage() {
    const mainImageDiv = document.querySelector('.cd-image-canopay');
    const variantImageContainer = document.getElementById('varient-image-update');
    if (mainImageDiv && variantImageContainer) {
      variantImageContainer.innerHTML = mainImageDiv.innerHTML;
    }
  }

  function hookGoToStep() {
    const prevGo = window.goToStep;
    window.goToStep = function (stepNumber) {
      const ok = typeof prevGo === 'function' ? prevGo(stepNumber) : true;
      if (ok === false) return false;

      if (VARIANT_IMAGE_STEPS.includes(Number(stepNumber))) {
        setTimeout(syncVariantImageForActiveStep, 50);
      }

      return ok;
    };

    const prevSub = window.goToSubStep;
    window.goToSubStep = function (stepName) {
      const ok = typeof prevSub === 'function' ? prevSub(stepName) : true;
      if (ok === false) return false;

      setTimeout(syncVariantImageForActiveStep, 50);
      return ok;
    };
  }

  /**
   * STEP 1 (VAN MODEL) — update image when a variant radio is selected.
   */
  function updateStep1VariantImage(radio) {
    if (!radio || !radio.checked) return;

    const label =
      (radio.id && document.querySelector('label[for="' + radio.id + '"]')) ||
      radio.closest('label.cd-custom-varient');

    if (label) setVariantImageFromLabel(label);
  }

  function initStep1VariantImage() {
    const step1 = document.getElementById('step1');
    if (!step1) return;

    const checked = step1.querySelector('.cd-custom-varient input[type="radio"]:checked');
    if (checked) updateStep1VariantImage(checked);

    step1.addEventListener('change', function (e) {
      if (
        e.target.matches('input[type="radio"]') &&
        !e.target.classList.contains('addon-checkbox')
      ) {
        updateStep1VariantImage(e.target);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    setDefaultImage();
    hookGoToStep();
    initStep1VariantImage();

    document.addEventListener('change', function (e) {
      if (!e.target.classList.contains('addon-checkbox')) return;

      const label = e.target.closest('label.cd-custom-varient');
      const imageBox = document.getElementById('varient-image-update');
      const mainImageDiv = document.querySelector('.cd-image-canopay');

      if (e.target.checked && label) {
        setVariantImageFromLabel(label);
      } else if (mainImageDiv && imageBox) {
        imageBox.innerHTML = mainImageDiv.innerHTML;
      }
    });
  });
})();